import * as constants from '../constants/constants';
import { apiCaller, axiosCaller } from "../utils/apiCaller";
import {ACTION, setLoading, setButtonLoading, wrap} from './generalActions'
import {GET_MATERIALS_OF_PRODUCT} from "../constants/constants";

export const fetchProductionClients = (page = 1, perPage = 20, search = '', productionFilter = '', departmentId = '', workerId = '') => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true));
        dispatch(setButtonLoading(true));
        let url = `clients/advanced-search?page=${page}&per_page=${perPage}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;

        const body: any = { moduleId: 5 };
        if (productionFilter) body.productionFilter = productionFilter;
        if (departmentId) body.departmentId = departmentId;
        if (workerId) body.workerId = workerId;

        return await apiCaller('POST', url, body).then((res: any) => {
            dispatch({ type: constants.FETCH_CLIENTS_BY_MODULE_DATA, payload: res });
            dispatch(setLoading(false));
            dispatch(setButtonLoading(false));
            return res;
        });
    } catch (err) {
        dispatch(setLoading(false));
        dispatch(setButtonLoading(false));
    }
}, 'FETCH_PRODUCTION_CLIENTS_ERROR')

export const getProductionDashboardStats = (category?: 'production' | 'activity' | '') => wrap(async (dispatch: any) => {
    try {
        const qs = category ? `?category=${category}` : '';
        return await apiCaller('GET', `products/production-dashboard-stats${qs}`).then(res => res)
    } catch (err) {
        // silent fail
    }
}, 'GET_PRODUCTION_DASHBOARD_STATS_ERROR')

export const getArchivedResponsibilitiesDashboardStats = () => wrap(async (dispatch: any) => {
    try {
        return await apiCaller('GET', 'archive/statuses/dashboard-stats').then(res => res)
    } catch (err) {
        // silent fail
    }
}, 'GET_ARCHIVED_RESP_DASHBOARD_STATS_ERROR')

export const getArchivedProductsDashboardStats = () => wrap(async (dispatch: any) => {
    try {
        return await apiCaller('GET', 'products/archived-products-dashboard-stats').then(res => res)
    } catch (err) {
        // silent fail
    }
}, 'GET_ARCHIVED_PRODUCTS_DASHBOARD_STATS_ERROR')

export const fetchResponsibilities = () => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('GET', `responsibilities`).then(res => {
            dispatch({ "type": constants.FETCH_RESPONSIBILITIES, "payload": res.data.data });
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'FETCH_RESPONSIBILITIES')


export const fetchUserResponsibilities = () => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('GET', `responsibilities/user-responsibilities`).then(res => {
            dispatch({ "type": constants.FETCH_USER_RESPONSIBILITIES, "payload": res.data.data });
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'FETCH_USER_RESPONSIBILITIES')

export const fetchProductionTableData = (clientId: number) => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('GET', `clients/${clientId}/products`).then(res => {
            dispatch({ "type": constants.FETCH_PRODUCTION_TABLE_DATA, "payload": res.data });
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'FETCH_PRODUCTION_TABLE_DATA')

export const fetchProductStatuses = (departmentId?, startDate?, endDate?, done?, searchName?, responsibilityId?, responsibilityStatusId?, sort?, filterDatesBy?, shipmentDestinationId?) => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('GET', `clients/products-statuses?moduleId=5&active=1${done ? `&done=${done}` : '&done=0'}${departmentId && departmentId != 'null' ? `&departmentId=${departmentId}`: ''}${startDate && endDate ? `&start=${startDate}&end=${endDate}` : ''}${searchName ? `&name=${searchName}`: ''}${responsibilityId ? `&responsibilityId=${responsibilityId}`: ''}${responsibilityStatusId ? `&responsibilityStatusId=${responsibilityStatusId}`: ''}${sort ? `&sort=${sort}` : ''}${filterDatesBy ? `&filterDatesBy=${filterDatesBy}` : ''}${shipmentDestinationId ? `&shipmentDestinationId=${shipmentDestinationId}` : ''}`).then(res => {
            dispatch({ "type": constants.FETCH_PRODUCT_STATUSES, "payload": res.data });
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'FETCH_PRODUCT_STATUSES')

export const fetchProductPrices = (departmentId?, startDate?, endDate?, done?, searchName?, responsibilityId?, responsibilityStatusId?, sort?, filterDatesBy?, measureStatusId?, page = 1, perPage = 20, overallStatus?, opts?: { departmentIds?: number[], overallStatuses?: number[], clientId?: number, hasStartedRealWork?: boolean, category?: 'production' | 'activity' | '', workState?: 'active' | 'idle' | '' }) => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        let qs: string[] = ['active=1', `done=${done || 0}`, `page=${page}`, `per_page=${perPage}`];
        // Multi-department (new) takes priority over single departmentId (legacy)
        if (opts?.departmentIds && opts.departmentIds.length > 0) {
            opts.departmentIds.forEach(id => qs.push(`departmentIds[]=${id}`));
        } else if (departmentId && departmentId != 'null') {
            qs.push(`departmentId=${departmentId}`);
        }
        if (startDate && endDate) { qs.push(`start=${startDate}`); qs.push(`end=${endDate}`); }
        if (searchName) qs.push(`name=${searchName}`);
        if (responsibilityId) qs.push(`responsibilityId=${responsibilityId}`);
        if (responsibilityStatusId) qs.push(`responsibilityStatusId=${responsibilityStatusId}`);
        if (sort) qs.push(`sort=${sort}`);
        if (filterDatesBy) qs.push(`filterDatesBy=${filterDatesBy}`);
        if (measureStatusId) qs.push(`measureStatusId=${measureStatusId}`);
        // Multi-status (new) takes priority over single overallStatus (legacy)
        if (opts?.overallStatuses && opts.overallStatuses.length > 0) {
            opts.overallStatuses.forEach(s => qs.push(`overallStatuses[]=${s}`));
        } else if (overallStatus) {
            qs.push(`overallStatus=${overallStatus}`);
        }
        if (opts?.clientId) qs.push(`clientId=${opts.clientId}`);
        if (opts?.hasStartedRealWork) qs.push(`hasStartedRealWork=1`);
        if (opts?.category) qs.push(`category=${opts.category}`);
        if (opts?.workState) qs.push(`workState=${opts.workState}`);
        return await axiosCaller('GET', `products/view-price?${qs.join('&')}`).then(res => {
            dispatch({ "type": constants.FETCH_PRODUCT_PRICES, "payload": res.data });
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'FETCH_PRODUCT_STATUSES')

export const fetchPassiveProductStatuses = (departmentId?, startDate?, endDate?, page: number = 1, perPage: number = 20, search: string = '') => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));

        let queryParams: string[] = ['moduleId=5', 'active=0', 'done=0'];
        if (departmentId && departmentId != 'null') queryParams.push(`departmentId=${departmentId}`);
        if (startDate && endDate) {
            queryParams.push(`start=${startDate}`);
            queryParams.push(`end=${endDate}`);
        }
        queryParams.push(`page=${page}`);
        queryParams.push(`per_page=${perPage}`);
        if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
        const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

        return await axiosCaller('GET', `clients/products-statuses${queryString}`).then(res => {
            dispatch({ "type": constants.FETCH_PASSIVE_PRODUCTS, "payload": res.data });
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'FETCH_PRODUCT_STATUSES')

export const fetchWarehouseProducts = (startDate?, endDate?, departmentId?, shipmentDestinationId?, page = 1, perPage = 20, search = '') => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));

        // Build query parameters
        let queryParams: string[] = [];
        if (startDate && endDate) {
            queryParams.push(`start=${startDate}&end=${endDate}`);
        }
        if (departmentId) {
            queryParams.push(`departmentId=${departmentId}`);
        }
        if (shipmentDestinationId) {
            queryParams.push(`shipmentDestinationId=${shipmentDestinationId}`);
        }
        queryParams.push(`page=${page}`);
        queryParams.push(`per_page=${perPage}`);
        if (search) {
            queryParams.push(`search=${encodeURIComponent(search)}`);
        }

        const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

        return await axiosCaller('GET', `products/warehouse-products${queryString}`).then(res => {
            dispatch({ "type": constants.FETCH_WAREHOUSE, "payload": res.data });
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'FETCH_WAREHOUSE')

export const addArticlesToWarehouse = (payload) => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('POST', `warehouse/store`, payload).then(res => {
            dispatch({ "type": constants.ADD_ARTICLES_TO_WAREHOUSE, "payload": res.data });
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'ADD_ARTICLES_TO_WAREHOUSE')

export const updateProductDates = (payload) => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('POST', `admin/products/change-start-end-date`, payload).then(res => {
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
            return res
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'UPDATE_PRODUCT_DATES')

export const getMaterialsForProductAndResponsibility = (productId: number, responsibilityId: number) => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('GET', `products/responsibilities-materials?productId=${productId}&responsibilityId=${responsibilityId}`).then((res) => {
            dispatch({ "type": constants.GET_MATERIALS_FOR_PRODUCTS_AND_RESPONSIBILITY, "payload": res.data });
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
            return res.data.data
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'UPDATE_PRODUCT_DATES')

export const createBlueprint = (payload) => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('POST', `project-blueprint`, payload).then(() => {
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'CREATE_BLUEPRINT_FILES')

export const getBlueprintFiles = (productId) => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('GET', `project-blueprint/${productId}/products`).then((res) => {
            dispatch({ "type": constants.GET_BLUEPRINT_FILES, "payload": res.data });
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'GET_BLUEPRINT_FILES')

export const deleteBlueprintFile = (fileId) => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('DELETE', `project-blueprint/${fileId}`).then(() => {
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'GET_BLUEPRINT_FILES')

export const saveTimeTracked = (payload) => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('POST', `trackers`, payload).then(() => {
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'CREATE_BLUEPRINT_FILES')

export const editTimeTracked = (payload, trackId) => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('POST', `trackers/${trackId}`, payload).then(() => {
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'CREATE_BLUEPRINT_FILES')

export const getCurrentTimeTracked = (payload) => wrap(async (dispatch: any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('POST', `trackers/tracker`, payload).then((res) => {
            dispatch({ "type": constants.GET_CURRENT_RESPONSIBILITY_TIME, "payload": res.data.data });
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
    }
}, 'CREATE_BLUEPRINT_FILES')

export const getMaterialsOfProduct = (productId) => wrap(async (dispatch: any) => {
    try {
       dispatch(setButtonLoading(true));
        return await axiosCaller('GET', `clients/materials/statuses?productId=${productId}`).then((res) => {
            dispatch({ "type": constants.GET_MATERIALS_OF_PRODUCT, "payload": res.data?.data });
            dispatch(setButtonLoading(false));
            return res?.data?.data
        })
    } catch(err) {
        dispatch(setButtonLoading(false));
    }
}, 'CREATE_BLUEPRINT_FILES')


export const setSelectedTrack = (payload: any): ACTION => ({
    type: constants.GET_CURRENT_RESPONSIBILITY_TIME,
    payload
});

export const fetchProductStatusesChanges = (since: string, departmentId?: any, done?: any, search?: string, responsibilityId?: any, responsibilityStatusId?: any, sort?: string, filterDatesBy?: string) => wrap(async (dispatch: any) => {
    try {
        let url = `clients/products-statuses-changes?moduleId=5&active=1&done=${done || 0}&since=${encodeURIComponent(since)}`;
        if (departmentId && departmentId != 'null') url += `&departmentId=${departmentId}`;
        if (search) url += `&name=${encodeURIComponent(search)}`;
        if (responsibilityId) url += `&responsibilityId=${responsibilityId}`;
        if (responsibilityStatusId) url += `&responsibilityStatusId=${responsibilityStatusId}`;
        if (sort) url += `&sort=${sort}`;
        if (filterDatesBy) url += `&filterDatesBy=${filterDatesBy}`;

        const res = await axiosCaller('GET', url);
        return res?.data;
    } catch (err) {
        return null;
    }
}, 'FETCH_PRODUCT_STATUSES_CHANGES_ERROR');

export const setProductStatuses = (data: any) => (dispatch: any) => {
    dispatch({ type: constants.FETCH_PRODUCT_STATUSES, payload: { data } });
};

export const fetchReturnCategories = () => wrap(async (dispatch: any) => {
    try {
        return await axiosCaller('GET', 'return-categories').then((res) => {
            dispatch({ type: constants.FETCH_RETURN_CATEGORIES, payload: res.data });
            return res.data;
        });
    } catch (err) {
        // silent fail
    }
}, 'FETCH_RETURN_CATEGORIES_ERROR');